import { DEFAULT_BACKGROUND_CONFIG } from '@atlassian/jira-custom-theme-constants/src/constants.tsx';
import type { OverviewTheme } from '@atlassian/jira-custom-theme-constants/src/types.tsx';
import { useOverview } from '@atlassian/jira-router-resources-business-overview-details/src/index.tsx';

export const useOverviewTheme = (): OverviewTheme | null => {
	const { data } = useOverview();

	if (data != null) {
		return {
			themeSetting: { type: 'color', value: data.theme ?? DEFAULT_BACKGROUND_CONFIG.name },
			entityId: `overview/${data.id}`,
		};
	}

	return null;
};
